/**
 * FE mirror of BE stale-filter vocabulary. BE owns the canonical values;
 * this module re-declares the same literal strings so a bare comparison
 * against `'invalid_filter_values'` etc. isn't scattered through the FE.
 * Rename on either side then fails typechecking here. Add a value the
 * moment the BE ships one; see the feature-root AGENTS.md.
 */

/** Values must match BE `FilterIssueKind` (`agent_run_failure.py`). */
export const FilterIssueKind = {
  /** Field is valid; specific values in it don't resolve. */
  UnknownValues: 'unknown_values',
  /** The field itself isn't in this project's taxonomy. */
  UnknownField: 'unknown_field',
  /** Field is a numeric range being used as a list. */
  RangeFieldMisuse: 'range_field_misuse',
  /**
   * Theme cluster was deleted from the taxonomy — the display name is gone,
   * only the uuid survives. Distinct from `UnknownValues` so callers can
   * render "[Deleted Value]" instead of a raw uuid.
   */
  UnresolvableTheme: 'unresolvable_theme',
} as const

export type FilterIssueKind =
  (typeof FilterIssueKind)[keyof typeof FilterIssueKind]

/** Agent-neutral. Both `IssueAgentRunStatusMessage` and
 *  `BenchmarkingAgentRunStatusMessage` on the BE emit the same wire string
 *  for `invalid_filter_values`, so the FE mirrors one shared vocabulary
 *  rather than one namespace per agent kind. Mirror only what the FE
 *  consumes — add a value the moment a consumer needs it. */
export const AgentRunStatusMessage = {
  /** Run failed because saved filters no longer resolve. Specific offending
   * values are re-computed at read time from `agent.stale_filters`. */
  InvalidFilterValues: 'invalid_filter_values',
} as const

export type AgentRunStatusMessage =
  (typeof AgentRunStatusMessage)[keyof typeof AgentRunStatusMessage]
